{
  "baseLayout": {
    "backButton": "Atrás",
    "menuButton": "Menú"
  },
  "reporting": {
    "selectReportButton": "Seleccionar reporte",
    "viewBookingButton": "Ver reserva"
  },
  "bookingButtons": {
    "addFavJourneyButton": "Agregar viaje favorito",
    "clearFavJourneyButton": "Quitar viaje favorito",
    "editBookingButton": "Editar reserva",
    "shareBookingButton": "Compartir reserva",
    "sendConfirmationButton": "Enviar confirmación",
    "copyBookingButton": "Copiar reserva",
    "returnBookingButton": "Reserva de regreso",
    "cancelBookingButton": "Cancelar reserva",
    "addToCalendarButton": "Agregar la reserva al calendario",
    "moreActionsButton": "Más acciones de reserva"
  },
  "newBooking": {
    "favJourneyCard": "Reservar viaje favorito",
    "recentJourneyCard": "Reservar viaje reciente",
    "favJourneyEdit": "Editar la descripción del viaje favorito",
    "favJourneyClear": "Quitar viaje favorito",
    "selectBookingTemplateButton": "Comenzar reserva"
  },
  "masquerading": {
    "changeContactButton": "Cambiar contacto",
    "selectContactButton": "Seleccionar contacto",
    "clearContactButton": "Borrar contacto"
  },
  "bookingForm": {
    "stops": {
      "editStopButton": "Editar la dirección de la parada",
      "saveAddressButton": "Guardar la dirección en el perfil",
      "removeStopButton": "Quitar parada",
      "reorderStops": "Reordenar paradas",
      "selectFlightCard": "Seleccionar vuelo",
      "removeFlightButton": "Quitar los datos del vuelo",
      "stopsInputAccordion": "Ver más detalles",
      "mapSearchButton": "Buscar en el mapa",
      "asDirectedButton": "Según indicaciones",
      "clearSearchButton": "Borrar búsqueda",
      "selectAddressButton": "Seleccionar dirección"
    },
    "tariffs": {
      "reverseSort": "Invertir el orden de las tarifas"
    }
  },
  "profile": {
    "cards": {
      "makeDefaultCardButton": "Usar como tarjeta predeterminada",
      "deleteCardButton": "Eliminar tarjeta",
      "selectCard": "Seleccionar tarjeta"
    },
    "addresses": {
      "addAddressButton": "Agregar nueva dirección",
      "addressFilterButton": "Filtro de direcciones",
      "reorderAddresses": "Reordenar direcciones"
    },
    "addContactLinkButton": "Agregar vínculo de contacto"
  },
  "selectProfileCard": "Seleccionar perfil",
  "clearSelectionButton": "Borrar selección",
  "refreshChip": "Actualizar contenido",
  "passwordToggle": "Mostrar u ocultar la contraseña",
  "countryInputField": "Seleccionar país / región",
  "localeInput": "Seleccionar idioma",
  "viewBooking": {
    "openDocument": "Abrir documento"
  }
}
